var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight2 = function SvgArrowRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.887 5.028a.766.766 0 0 0 0-1.062L7.244.218a.715.715 0 0 0-1.032 0 .766.766 0 0 0 0 1.061l2.403 2.47H1.629a.739.739 0 0 0-.729.75c0 .414.326.749.729.749h6.983l-2.397 2.47a.766.766 0 0 0 0 1.06.715.715 0 0 0 1.031 0L10.89 5.03l-.002-.002Z"
  })));
};
export default SvgArrowRight2;